const noModalPages = ['page-cartPage', 'page-premium-shop-new'];

// The back-order modal is identified by its inner element, matching AddToCartModalManager.
const BACK_ORDER_MODAL_SELECTOR = '#addToCartBackOrderModal';

const isNoModalPage = () =>
	noModalPages.some(pageClass => document.body.classList.contains(pageClass));

const isBackOrderModal = html =>
	Boolean(html?.querySelector?.(BACK_ORDER_MODAL_SELECTOR));

// Skip the add-to-cart modal (and reload instead) on no-modal pages — except for the back-order
// modal, which asks the customer to choose stock options and must always be shown.
export const shouldSkipModal = html =>
	isNoModalPage() && !isBackOrderModal(html);

export const addToCartSkipModal = html => {
	// Reuse shouldSkipModal so the back-order modal is never reloaded away, even if this is called
	// on a no-modal page — the guard must match the condition that decides to skip the modal.
	if (!shouldSkipModal(html)) {
		return;
	}

	setTimeout(() => {
		window.location.reload();
	}, 0);
};
